import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TextSizeEnum} from '../../../enums/text-size.enum';
import {SliderResponseModel} from '@shared/components/slider/model/slider-response.model';

@Component({
    selector: 'app-display-consent-settings',
    templateUrl: './display-consent-settings.component.html',
    styleUrls: ['./display-consent-settings.component.scss']
})
export class DisplayConsentSettingsComponent {
    @Input() textSize: TextSizeEnum;
    @Output() sliderChangeEvent: EventEmitter<SliderResponseModel> = new EventEmitter<SliderResponseModel>();

    values = Object.values(TextSizeEnum);
}
